export default __webpack_public_path__ + "static/media/check_icon.2f853e56.svg";